<template>
  <section>
    <v-card v-if="subirArchivo">
      <v-card-text>
        <template>
          <v-toolbar dense>
              <v-btn flat xs1 :disabled="!this.habilitado" @click="adjuntar(false)">
                <v-icon>clear</v-icon>
              </v-btn>
              <v-btn @click="enviarDocumentos()" color="success" :disabled="!this.habilitado || !this.enviado || this.archivos.length === 0">
                <v-icon>send</v-icon> Enviar
              </v-btn>
          </v-toolbar>
        </template>
        <file-upload :key="fileUploadKey" :label="'Arrastra el archivo aquí'" :max-files="5" :types="opcionesArchivo" @recuperar="archivosSeleccionados"></file-upload>
      </v-card-text>
    </v-card>
    <v-card v-if="!subirArchivo">
      <div ref="enviomensajes">
      <v-form>
      <v-card-text>
        <template>
          <v-toolbar dense>
            <v-overflow-btn
              :items="tramites"
              v-model="tramiteSeleccionado"
              :label="$t('tramites.label')"
              item-text="nombre_tramite"
              item-value="id"
              hide-details
              :no-data-text="$t('$vuetify.noDataText')">
            </v-overflow-btn>
            <v-divider vertical></v-divider>
            <v-overflow-btn
              :items="respuestas"
              v-model="respuestaSeleccionada"
              :label="$t('tramites.quick_response')"
              hide-details
              :no-data-text="$t('$vuetify.noDataText')">
            </v-overflow-btn>
            <v-divider
              class="mr-2"
              vertical
            ></v-divider>
              <v-tooltip top>
                <v-btn icon flat xs1 :disabled="!this.habilitado" @click="adjuntar(true)" slot="activator">
                  <v-icon>attach_file</v-icon>
                </v-btn>
                <span>Adjuntar archivo</span>
              </v-tooltip>
              <v-menu
                v-model="menuAudio"
                :close-on-content-click="false"
                :nudge-width="200"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-tooltip top>
                      <v-btn
                        icon
                        flat
                        v-on="on"
                        :disabled="!habilitado || !habilitarAudio"
                        slot="activator"
                      >
                        <v-icon>mic</v-icon>
                      </v-btn>
                      <span>Grabar audio</span>
                  </v-tooltip>
                </template>

                <v-card>
                  <v-card-text class="text-md-center">
                    <audio-recorder @recuperar="audioGrabado"></audio-recorder>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="red"
                      @click.native="menuAudio = false">
                      <v-icon>close</v-icon> {{$t('common.cancel') }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      @click.native="enviarAudio()"
                      :disabled="!audio">
                      <v-icon>send</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
              <v-btn icon @click="enviar()" color="success" :disabled="!this.habilitado || !this.enviado || !this.mensaje || this.mensaje === ''">
                <v-icon>send</v-icon>
              </v-btn>
          </v-toolbar>
        </template>
        <v-textarea
          solo
          v-model="mensaje"
          name="input-7-4"
          label="Enviar respuesta"
          placeholder="Escriba aqui...."
          value=""
          @keyup.enter.native="enviar($event)"
        ></v-textarea>
      </v-card-text>
      </v-form>
      </div>
    </v-card>
  </section>
</template>
<script>
import axios from 'axios';
import AudioRecorder from '@/common/plugins/audio/Recorder';
import FileUpload from '@/common/plugins/file/Upload.vue';
export default {
  props: {
    enviado: {
      type: Boolean,
      default: true
    },
    exito: {
      type: Boolean,
      default: false
    },
    opcionesArchivo: {
      type: Array,
      default: []
    },
    habilitarAudio: {
      type: Boolean,
      default: true
    }
  },
  created () {
    this.user = this.$storage.getUser();
    this.idEntidad = this.user.id_entidad;
  },
  beforeDestroy () {},
  mounted () {
    this.recuperarTramites();
    ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
      this.$refs.enviomensajes.addEventListener(evt, function (e) {
        e.preventDefault();
        e.stopPropagation();
      }, false);
    }.bind(this), false);
    this.$refs.enviomensajes.addEventListener('dragover', function (e) {
      this.subirArchivo = true;
    }.bind(this));
  },
  data () {
    return {
      archivos: [],
      mensaje: '',
      subirArchivo: false,
      habilitado: true,
      idEntidad: 0,
      tramites: [],
      respuestas: [],
      tramiteSeleccionado: 0,
      respuestaSeleccionada: '',
      menuAudio: false,
      audio: null,
      respuesta: {},
      fileUploadKey: 'fileUploadKey'
    };
  },
  computed: {},
  watch: {
    exito () {
      if (this.exito) {
        this.audio = null;
        this.archivos = [];
        this.tramiteSeleccionado = 0;
        this.respuestaSeleccionada = '';
        this.mensaje = '';
        this.fileUploadKey = 'fileUploadKey' + Math.random().toString(36).substr(2, 5);
      }
    },
    tramiteSeleccionado (val) {
      if (val > 0) {
        this.recuperarRespuestas();
      }
    },
    mensaje () {
      this.$emit('mensaje', this.mensaje);
    },
    respuestaSeleccionada () {
      this.mensaje = this.respuestaSeleccionada;
    }
  },
  methods: {
    adjuntar (estado) {
      this.subirArchivo = estado;
    },
    grabarAudio () {
      this.audio = null;
    },
    audioGrabado (value) {
      this.audio = value;
      this.archivos = [];
      this.archivos.push({extension: 'mp3', base64: this.audio, tipo: 'audio', nombre: 'audio.mp3'});
      // this.subirArchivo = true;
      this.$emit('archivos', this.archivos);
    },
    archivosSeleccionados (value) {
      this.archivos = value;
      this.$emit('archivos', this.archivos);
    },
    recuperarTramites () {
      if (this.idEntidad) {
        this.tramites = [];
        this.$service.get(`system/tramites`, {})
        .then(response => {
          if (response) {
            this.tramites = response.rows;
          }
        });
      }
    },
    recuperarRespuestas () {
      if (this.tramiteSeleccionado) {
        this.respuestas = [];
        this.$service.get(`system/faqs/tramite/${this.tramiteSeleccionado}`, {})
        .then(response => {
          if (response) {
            response.rows.forEach((item) => {
              this.respuestas.push(item.respuesta);
            });
          }
        });
      }
    },
    enviar (event) {
      if ((!event || !event.shiftKey) && this.mensaje && this.mensaje.length > 1) {
        this.$emit('enviar', 'mensaje');
      }
    },
    enviarAudio () {
      this.$emit('enviar', 'archivos');
    },
    enviarDocumentos () {
      this.$emit('enviar', 'archivos');
    }
  },
  updated () {},
  components: { axios, AudioRecorder, FileUpload }
};
</script>



// WEBPACK FOOTER //
// src/common/plugins/editor/Editor.vue